(function canelitaRandomProducts() {
  // Section IDs que contienen productos en el homepage, en orden de prioridad
  const SECTIONS = [
    'product_list_novedades',
    'product_list_tendencias',
    'product_list_outlet'
  ];

  const SEED_KEY = 'canelita_rand_seed';

  // Semilla por sesión — se genera una vez y persiste durante la visita
  let seed;
  try {
    seed = parseInt(sessionStorage.getItem(SEED_KEY), 10);
    if (!seed || isNaN(seed)) {
      seed = Math.floor(Math.random() * 2147483647);
      sessionStorage.setItem(SEED_KEY, String(seed));
    }
  } catch (_) {
    seed = Date.now() & 0x7fffffff;
  }

  // Generador LCG pseudoaleatorio determinista a partir de la semilla
  function makeRand(s) {
    let state = s >>> 0;
    return function () {
      state = Math.imul(state, 1664525) + 1013904223 >>> 0;
      return state / 4294967296;
    };
  }

  // Fisher-Yates con generador propio
  function shuffle(arr, rand) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      const tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  // Extrae el handle del producto desde cualquier enlace /products/handle dentro de la tarjeta
  function getHandle(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function run() {
    const rand = makeRand(seed);
    const seen = new Set();

    SECTIONS.forEach(function (sectionId) {
      const section = document.getElementById('shopify-section-' + sectionId);
      if (!section) return;

      // Horizon renderiza los productos dentro de un <ul> dentro del section
      const grid = section.querySelector('ul');
      if (!grid) return;

      const items = Array.from(grid.querySelectorAll(':scope > li'));
      if (!items.length) return;

      // Barajar con la semilla de sesión
      const shuffled = shuffle(items, rand);

      // Filtrar productos ya vistos en secciones anteriores
      const unique = shuffled.filter(function (item) {
        const handle = getHandle(item);
        if (!handle || seen.has(handle)) return false;
        seen.add(handle);
        return true;
      });

      // Limpiar y reinsertar en nuevo orden
      shuffled.forEach(function (item) { item.remove(); });
      unique.forEach(function (item) { grid.appendChild(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
